
<div class="mb-20">
  @if (question?.question_prompt) {
    <div class="notice notice--info">
      <div class="notice__content">
        <svg class="icon">
          <use xlink:href="#info"></use>
        </svg>
        <p [innerHTML]="question?.question_prompt"> </p>
      </div>
    </div>
  }
</div>

@if (showAgree) {
  <div class="form-group text-center">
    <label class="custom-toggle custom-toggle--ml custom-toggle--inline">
      <input
        type="checkbox"
        [checked]="agree"
        [(ngModel)]="agree"
        (ngModelChange)="setAgree()"
        name="add-note-toggle"
        id="skip-driver-details-toggle">
        <span class="custom-toggle__indi"></span>
        <span class="custom-toggle__label">I agree</span>
      </label>
    </div>
  }



